
@switch (status) {
  @case ('IDLE') {
    <mat-icon matTooltipPosition="right" [matTooltip]="'Not synchronized'"
      class="material-icons-outlined">pending
    </mat-icon>
  }
  @case ('IN_PROGRESS') {
    <mat-spinner matTooltipPosition="right" [matTooltip]="'Synchronizing...'"
    [diameter]="24"></mat-spinner>
  }
  @case ('COMPLETE') {
    <mat-icon matTooltipPosition="right" [matTooltip]="'Synchronized'" class="complete-icon">
      done
    </mat-icon>
  }
  @case ('WARNING') {
    <mat-icon matTooltipPosition="right" [matTooltip]="message"
      class="warning-icon">warning
    </mat-icon>
  }
  @case ('FAILED') {
    <mat-icon matTooltipPosition="right" [matTooltip]="message || 'Synchronization failed'"
      class="failed-icon">error
    </mat-icon>
  }
  @case ('DELETING') {
    <mat-spinner matTooltipPosition="right" [matTooltip]="'Deleting index...'"
                 [diameter]="24"></mat-spinner>
  }
  @case ('DELETED') {
    <mat-icon matTooltipPosition="right" [matTooltip]="'Dictionary is deleted in TermWeb'"
      class="failed-icon">clear
    </mat-icon>
  }
  @case ('UNAVAILABLE') {
    <mat-icon matTooltipPosition="right" [matTooltip]="'TermWeb is not accessible — status unknown'"
              class="warning-icon">cloud_off
    </mat-icon>
  }
}
